import { render, staticRenderFns } from "./swatch.vue?vue&type=template&id=b7bc1bd6"
import script from "./swatch.vue?vue&type=script&lang=js"
export * from "./swatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports